import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import ViewAllUserLayer from "../components/ViewAllUserLayer";


const ViewAllUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View All User" />

   
        <ViewAllUserLayer />


      </MasterLayout>
    </>
  );
};

export default ViewAllUserPage;
